// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form-item .el-form-item[data-v-630077b8] {\n  margin-bottom: 22px;\n}\n", ""]);
// Exports
module.exports = exports;
